__webpack_require__.p = "/reports-color-coding/onboarding/";